import {
    NinchatActionType,
    NinchatAssignTranscriptAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatAckEvent} from 'api/types/events'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const assignTranscript = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatAssignTranscriptAction}`,
    async (arg: NinchatActionParams<NinchatAssignTranscriptAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatAssignTranscriptAction

        try {
            return await ninchatClient.send(params) as NinchatAckEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
